import React, { ReactElement, useEffect, useState } from 'react';
import { Form, Input, Select, Switch, Radio } from 'antd';
import styles from './AppForm.module.less';
import { Validator } from 'ip-num/Validator';
import { IPv4 } from 'ip-num/IPNumber';
import { IPv4CidrRange } from 'ip-num/IPRange';
import { InputNumber } from 'antd';
import AppFormSlider from './AppFormSlider';
import AppFormFlagSelect from './AppFormFlagSelect';
import CcxComponentProps from '../../../core/CcxComponent';
import CcxIconInfoCircleOutlined from '../icons/CcxIconInfoCircleOutlined';
import { Tooltip } from 'antd';

interface Props extends CcxComponentProps {
    fields?: any[];
    form?: any;
    onPressEnter?: Function;
    errorFields?: any[];
    formClassName?: string;
    useGrid?: boolean;
}

function AppForm({
    fields,
    form,
    onPressEnter,
    errorFields,
    testId = 'AppForm',
    formClassName,
    useGrid = false,
}: Props): ReactElement {
    const { Option } = Select;

    useEffect(() => {
        // setIsChanged(false);
    }, [errorFields]);

    const getFormComponent = (field: any) => {
        if (!field) {
            return null;
        }

        switch (field.type) {
            case 'flagSelect':
                return (
                    <AppFormFlagSelect
                        field={field}
                        onPressEnter={onPressEnter}
                        testId={field.testId}
                    />
                );
            // return (
            //   <Select
            //     showSearch
            //     placeholder={field.placeholder}
            //     optionFilterProp="children"
            //     className={styles.AppFormInput}
            //     disabled={field.disabled}
            //     filterOption={(input: any, option: any) =>
            //       option?.props?.children?.props?.children[1]
            //         .toLowerCase()
            //         .indexOf(input?.toLowerCase()) >= 0
            //     }
            //     onChange={field.onChange}
            //   >
            //     {field.options.map((o: any) => {
            //       return (
            //         <Option value={o.value} key={o.value}>
            //           {o.label}
            //         </Option>
            //       );
            //     })}
            //   </Select>
            // );
            case 'select':
                // return (
                //   <AppFormSelect
                //     field={field}
                //     onPressEnter={onPressEnter}
                //     onChange={async (v: any) => {
                //       form?.setFieldsValue(field.name, v);
                //       await form?.validateFields();
                //     }}
                //   />
                // );
                return (
                    <Select
                        showSearch
                        placeholder={field.placeholder}
                        optionFilterProp="children"
                        className={styles.AppFormInput}
                        disabled={field.disabled}
                        filterOption={(input: any, option: any) =>
                            option?.props?.children?.props?.children[1]
                                .toLowerCase()
                                .indexOf(input?.toLowerCase()) >= 0
                        }
                        onChange={field.onChange}
                        data-testid={field.testId}
                    >
                        {field.options.map((o: any) => {
                            return (
                                <Option value={o.value} key={o.value}>
                                    {o.content || o.label}
                                </Option>
                            );
                        })}
                    </Select>
                );
            case 'multiple':
                // return (
                //   <AppFormSelect
                //     field={field}
                //     onPressEnter={onPressEnter}
                //     multiple={true}
                //   />
                // );
                return (
                    <Select
                        showSearch
                        mode="multiple"
                        placeholder={field.placeholder}
                        optionFilterProp="children"
                        className={styles.AppFormInput}
                        disabled={field.disabled}
                        filterOption={(input: any, option: any) =>
                            option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                        }
                        data-testid={field.testId}
                    >
                        {field.options.map((o: any) => {
                            return (
                                <Option value={o.value} key={o.value}>
                                    {o.label}
                                </Option>
                            );
                        })}
                    </Select>
                );
            case 'textarea':
                // return <AppFormTextArea field={field} onPressEnter={onPressEnter} />;
                return (
                    <Input.TextArea
                        className={styles.AppFormInput}
                        placeholder={field.placeholder || field.label}
                        disabled={field.disabled}
                        allowClear
                        onPressEnter={onPressEnter as any}
                        data-testid={field.testId}
                    />
                );
            case 'password':
                // return <AppFormInputPassword field={field} onPressEnter={onPressEnter} />;
                return (
                    <Input.Password
                        className={styles.AppFormInput}
                        placeholder={field.placeholder || field.label}
                        disabled={field.disabled}
                        allowClear
                        onPressEnter={onPressEnter as any}
                        data-testid={field.testId}
                    />
                );
            case 'ip':
            case 'cidr':
                // return <AppFormInput field={field} onPressEnter={onPressEnter} />;
                return (
                    <Input
                        className={styles.AppFormInput}
                        placeholder={field.placeholder || field.label}
                        disabled={field.disabled}
                        allowClear
                        onPressEnter={onPressEnter as any}
                        data-testid={field.testId}
                        onBlur={field.onBlur}
                    />
                );
            case 'radioGroup':
                // return <AppFormRadioGroup field={field} onPressEnter={onPressEnter} />;
                return (
                    <Radio.Group
                        className={
                            field.layout === 'vertical'
                                ? styles.AppFormRadioGroupVertical
                                : styles.AppFormRadioGroupHorizontal
                        }
                        disabled={field.disabled}
                        onChange={field.onChange}
                        data-testid={field.testId}
                    >
                        {field.options.map((o: any) => {
                            return (
                                <Radio.Button
                                    className={
                                        field.layout === 'vertical'
                                            ? styles.AppFormRadioGroupItemVertical
                                            : styles.AppFormRadioGroupItemHorizontal
                                    }
                                    disabled={field.disabled}
                                    value={o.value}
                                    onChange={field.onChange}
                                    key={o.value}
                                    {...{
                                        placeholder:
                                            field.placeholder || field.label,
                                        allowClear: true,
                                        onPressEnter: onPressEnter,
                                    }}
                                >
                                    {o.children}
                                </Radio.Button>
                            );
                        })}
                    </Radio.Group>
                );
            case 'hidden':
                // use html hidden input type
                // return <AppFormInputHidden field={field} />;
                return (
                    <input
                        type="hidden"
                        className={styles.AppFormInput}
                        placeholder={field.placeholder || field.label}
                        disabled={field.disabled}
                        data-testid={field.testId}
                    />
                );
            case 'rawElement':
                // rawElement fields are just ReactElement nodes that we return here
                return field.rawElement;
            case 'switch':
                return (
                    <Switch
                        className={styles.AppFormSwitch}
                        onChange={field.onChange}
                        data-testid={field.testId}
                    />
                );
            case 'slider':
                return (
                    <AppFormSlider field={field} onChange={field.onChange} />
                );
            case 'number':
                // return <AppFormInputNumber field={field} onPressEnter={onPressEnter} />;
                return (
                    <InputNumber
                        className={
                            field.align === 'left'
                                ? styles.AppFormInputNumberLeft
                                : styles.AppFormInputNumber
                        }
                        placeholder={field.placeholder || field.label}
                        disabled={field.disabled}
                        onPressEnter={onPressEnter as any}
                        min={field.minValue}
                        max={field.maxValue}
                        maxLength={field.maxLength}
                        formatter={field.formatter}
                        parser={field.parser}
                        step={field.step}
                        data-testid={field.testId}
                        onChange={field.onChange}
                    />
                );
            default:
                // return <AppFormInput field={field} onPressEnter={onPressEnter} />;
                return (
                    <Input
                        className={styles.AppFormInput}
                        placeholder={field.placeholder || field.label}
                        disabled={field.disabled}
                        allowClear
                        onChange={field.onChange}
                        onPressEnter={onPressEnter as any}
                        maxLength={field.maxLength}
                        data-testid={field.testId}
                    />
                );
        }
    };

    return (
        <div
            data-testid={testId}
            className={`${
                useGrid ? formClassName + ' ' + styles.AppRow : formClassName
            }`}
        >
            {fields?.map((field: any) => {
                const getFieldErrors = () => {
                    return errorFields
                        ? errorFields?.filter((f) => {
                              // f.name and field.name are like: ["source"]
                              return f.name[0] === field.name[0];
                          })
                        : [];
                };

                const hasErrors = () => {
                    return getFieldErrors().length > 0;
                };

                const helpText =
                    (hasErrors() &&
                        getFieldErrors()
                            .map((f: any) => {
                                return f.errors.join(' ');
                            })
                            .join()) ||
                    undefined;

                let validateStatus = null;
                if (!hasErrors()) {
                    validateStatus = 'success';
                } else {
                    validateStatus = 'error';
                }

                const checkReservedIp = (rule: any, value: any) => {
                    if (!value) {
                        // resolve to avoid showing validation errors
                        return Promise.resolve();
                    }

                    const cidrComponents = value.split('/');
                    const ip = cidrComponents[0];
                    if (!ip) {
                        return Promise.resolve();
                    }
                    const [validIpv4String] = Validator.isValidIPv4String(ip);
                    if (!validIpv4String) {
                        // resolve promise to address the case where the range is still not completed
                        // example: return valid for '0.0.' since the range is still being input.
                        // Other validators will catch the error if the cidr is not completed yet
                        return Promise.resolve();
                    }
                    const ipV4 = new IPv4(ip); // Creating an instance using the constructor

                    // https://jira.severalnines.com/browse/CCX-36
                    const reservedRange = [
                        '0.0.0.0/8',
                        '127.0.0.0/8',
                        '169.254.0.0/16',
                        '198.51.100.0/24',
                        '203.0.113.0/24',
                        '224.0.0.0/4',
                        '240.0.0.0/4',
                        '255.255.255.255/32',
                    ];

                    let valid = true;
                    reservedRange.forEach((r: string) => {
                        let ipv4Range = IPv4CidrRange.fromCidr(r);
                        if (
                            ipV4.isGreaterThanOrEquals(ipv4Range.getFirst()) &&
                            ipV4.isLessThanOrEquals(ipv4Range.getLast())
                        ) {
                            valid = false;
                        }
                    });

                    if (!valid) {
                        return Promise.reject('Cannot use a reserved IP range');
                    }

                    return Promise.resolve();
                };

                const checkCidr = (rule: any, value: any) => {
                    // https://ip-num.github.io/ip-num/classes/_validator_.validator.html#isvalidipv4cidrnotation
                    if (!value) {
                        // resolve to avoid showing validation errors
                        return Promise.resolve();
                    }

                    const [result, message] =
                        Validator.isValidIPv4CidrNotation(value);

                    if (result) {
                        return Promise.resolve();
                    }

                    return Promise.reject(message);
                };

                const checkIp = (rule: any, value: any) => {
                    // https://ip-num.github.io/ip-num/classes/_validator_.validator.html#isvalidipv4string
                    if (!value) {
                        // resolve to avoid showing validation errors
                        return Promise.resolve();
                    }

                    const [result, message] =
                        Validator.isValidIPv4String(value);

                    if (result) {
                        return Promise.resolve();
                    }

                    return Promise.reject(message);
                };

                const checkPatterns = (rule: any, value: any) => {
                    if (!value || !field.validators) {
                        return Promise.resolve();
                    }

                    let valid = true;
                    let message = '';

                    field.validators.forEach((v: any) => {
                        let regex = RegExp(v.pattern);
                        if (!regex.test(value)) {
                            valid = false;
                            message = v.message;
                        }
                    });

                    if (!valid) {
                        return Promise.reject(message);
                    }

                    return Promise.resolve();
                };

                let validationRules: any[] = field.rules || [];

                if (typeof field.label === 'string') {
                    validationRules.push({
                        required: field.required,
                        message: `${field.label} is required.`,
                    });
                } else if (field.validationName) {
                    validationRules.push({
                        required: field.required,
                        message: `${field.validationName} is required.`,
                    });
                }

                if (field.maxLength) {
                    validationRules.push({
                        max: field.maxLength,
                        message: `Up to ${field.maxLength} characters in length.`,
                    });
                }

                if (field.minLength) {
                    validationRules.push({
                        min: field.minLength,
                        message: `At least ${field.minLength} characters in length.`,
                    });
                }

                // if there are custom validation rules for this field (regexp patterns), add the pattern validator
                if (field.validators) {
                    validationRules.push({ validator: checkPatterns });
                }

                if (field.type === 'cidr') {
                    validationRules.push({ validator: checkCidr });
                    validationRules.push({ validator: checkReservedIp });
                }

                if (field.type === 'ip') {
                    validationRules.push({ validator: checkIp });
                }

                // Nested Form.Items below are for complex handling of the switch case. Adding a whitespace for
                // the switch placeholder makes the form validation to break. Form.Item validation only works with
                // a child that is an Input, Select, etc.
                // https://ant.design/components/form/#components-form-demo-complex-form-control
                return (
                    <Form.Item
                        label={
                            field.type === 'radioGroup' &&
                            field.layout !== 'vertical' ? null : (
                                <>
                                    {field.label}
                                    {field.tips ? (
                                        <Tooltip title={field.tips}>
                                            <div
                                                className={
                                                    styles.AppFormTipIcon
                                                }
                                            >
                                                <CcxIconInfoCircleOutlined />
                                            </div>
                                        </Tooltip>
                                    ) : null}
                                </>
                            )
                        }
                        validateStatus={validateStatus as any}
                        key={field.name}
                        required={field.required}
                        help={helpText}
                        extra={field.extra}
                    >
                        <Form.Item
                            name={field.name}
                            rules={validationRules}
                            noStyle
                            shouldUpdate={(
                                prevValues: any,
                                currentValues: any
                            ) => prevValues !== currentValues}
                            initialValue={
                                field.defaultValue ? field.defaultValue : null
                            }
                        >
                            {getFormComponent(field)}
                        </Form.Item>
                    </Form.Item>
                );
            })}
        </div>
    );
}

export default AppForm;
